import { useState, useCallback } from 'react';
import { getESM2to1Predictions } from '@/lib/api/esm2to1Api';
import { ESM2to1PredictionItem } from '@/types/esm2to1';

export function useESM2to1Predictions() {
  const [allPredictions, setAllPredictions] = useState<ESM2to1PredictionItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchESM2to1Predictions = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getESM2to1Predictions(filters);
      setAllPredictions(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load ESM 2-to-1 predictions. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    predictions: allPredictions,
    loading,
    error,
    fetchESM2to1Predictions,
  };
}
